import { useState } from "react";
import ExpandedUserFullName from "../../atoms/ExpandedUserFullName/ExpandedUserFullName";
import ToggleSwitch from "../../atoms/ToggleSwitch/ToggleSwitch";
import LabelledComboBox from "../../atoms/LabelledComboBox/LabelledComboBox";
import { ListPermission } from "../../../services/GiftsApi";
import "./FriendListPermission.scss";

interface FriendListPermissionProps {
    id: number;
    userName: string;
    firstName: string;
    lastName: string;
    permission: ListPermission;
    onChange: (permission: ListPermission) => void;
}

const FriendListPermission = (props: FriendListPermissionProps) => {

    const [permission, setPermission] = useState<ListPermission>(props.permission);

    return (
        <div className="friend-toggle">

            <ExpandedUserFullName userName={props.userName} firstName={props.firstName} lastName={props.lastName} />

            <div className="friend-toggle-switch">
                <ToggleSwitch checked={permission !== 'none'} onChange={p => {
                    setPermission(p ? 'view' : 'none');
                    props.onChange(p ? 'view' : 'none');
                }} />
            </div>

            {permission !== 'none' &&
                <div className="friend-role">
                    <LabelledComboBox name={`permission-${props.userName}`} label="Permissions:" value={permission} onChange={e => {
                        setPermission(e.target.value as ListPermission);
                        props.onChange(e.target.value as ListPermission);
                    }} options={[
                        { value: "view", label: "View: Can see the list and buy gifts" },
                        { value: "edit", label: "Edit: Can add and remove gifts in the list" }
                    ]} />
                </div>
            }
        </div>
    );
}

export default FriendListPermission;